<template>
  <div id="company_info" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>企業用戶</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="btn-group-lg" role="group" aria-label="Basic example">
          <button
            type="button"
            class="btn"
            @click="signingList"
            :class="showComponet === 'signingList' ? 'btn-warning' : ''"
          >
            電子簽單總表
          </button>
          <button
            type="button"
            class="btn"
            @click="invoiceList"
            :class="showComponet === 'invoiceList' ? 'btn-warning' : ''"
          >
            企業請款單
          </button>
          <button
            type="button"
            class="btn"
            @click="withdrawalList"
            :class="showComponet === 'withdrawalList' ? 'btn-warning' : ''"
          >
            司機領款單
          </button>
          <button
            type="button"
            class="btn"
            @click="clickEnterpriseList"
            :class="showComponet === 'enterpriseList' ? 'btn-warning' : ''"
          >
            企業列表
          </button>
        </div>
      </div>
    </div>
    <div v-show="showComponet === 'enterpriseList'">
      <el-row :gutter="8">
        <el-col :span="4">
          <h4>
            <i class="fa fa-user"></i>
            公司總數:
            <span class="red_textcolor">{{ count }}</span>
          </h4>
        </el-col>
        <el-col :span="2">
          <h4>查詢工號:</h4>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="value"
            placeholder="請選擇"
            @change="optEnterprise()"
          >
            <el-option
              v-for="enterprise in companys"
              :key="enterprise.name"
              :label="enterprise.name"
              :value="enterprise.name"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input v-model="jobNumber" placeholder="請輸入工號"></el-input>
          <span>*注意大小寫</span>
        </el-col>
        <el-col :span="4">
          <el-button
            type="primary"
            @click="searchEmployee"
            icon="el-icon-search"
          >
            搜尋
          </el-button>
        </el-col>
      </el-row>
      <div class="row">
        <table class="table table-striped jambo_table bulk_action">
          <thead>
            <tr class="headings">
              <th class="column-title">統一編號</th>
              <th class="column-title">企業名稱</th>
              <th class="column-title">聯絡人</th>
              <th class="column-title">聯絡人電話</th>
              <th class="column-title">動作</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(company, _) in companys">
              <tr class="pointer">
                <td class="fontSize16 tax-number" @click="nextPage(company.id)">
                  {{ company.taxIdNumber }}
                </td>
                <td class="fontSize16">{{ company.name }}</td>
                <td class="fontSize16">{{ company.contactName }}</td>
                <td class="fontSize16">{{ company.contactPhone }}</td>
                <td class="fontSize16">
                  <el-switch
                    class="enterprise-list-switch"
                    v-model="company.isTeamAuthorized"
                    @click.native.prevent="
                      allow(
                        company,
                        company.isTeamAuthorized ? 'allow' : 'nonAllow',
                      )
                    "
                    active-text="允許"
                    inactive-text="不允許"
                  ></el-switch>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <BasicModal
      ref="basicModal"
      :title="'企業員工資料'"
      :message="'message'"
    ></BasicModal>
    <SigningList v-show="showComponet === 'signingList'"></SigningList>
    <InvoiceList
      v-show="showComponet === 'invoiceList'"
      :companyList="companys"
    ></InvoiceList>
    <WithdrawalList v-show="showComponet === 'withdrawalList'" />
  </div>
</template>
<script>
import EnterpriseAPI from '@/assets/js/libs/EnterpriseAPI'
import InvoiceList from '@/components/company/InvoiceList'
import SigningList from '@/components/company/SigningList'
import WithdrawalList from '@/components/company/WithdrawalList'
import BasicModal from '@/components/element_ui/BasicModal'
import { cookies } from '@/utils/cookies'

export default {
  components: {
    SigningList,
    InvoiceList,
    WithdrawalList,
    BasicModal,
  },
  data() {
    return {
      value: '',
      count: 0,
      companys: [],
      npp: 25,
      page: 1,
      showComponet: 'signingList',
      enterpriseId: 0,
      jobNumber: '',
      enterprise: '',
    }
  },
  mounted() {
    EnterpriseAPI.defaults.headers.common['x-access-token'] =
      cookies.get('user')
    this.enterpriseList()
  },
  methods: {
    searchEmployee() {
      EnterpriseAPI.get(
        `enterprise/check_employee_auth/?enterprise_id=${this.enterpriseId}&job_number=${this.jobNumber}`,
      )
        .then((res) => {
          if (res.result === '無此乘客資料') {
            return this.$refs.basicModal.openModal('無此乘客資料')
          }
          let employeeInfo = `員工: ${res.result.name}, 工號: ${
            res.result.jobNunber
          }, 權限: ${res.result.authorize ? '開啟' : '關閉'}, 限制金額: ${
            res.result.payLimit === null ? '無' : res.result.payLimit
          }`
          this.$refs.basicModal.openModal(employeeInfo)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    optEnterprise() {
      for (let i = 0; i < this.companys.length; i++) {
        if (this.companys[i].name === this.value) {
          this.enterpriseId = this.companys[i].id
        }
      }
    },
    invoiceList() {
      this.showComponet = 'invoiceList'
    },
    withdrawalList() {
      this.showComponet = 'withdrawalList'
    },
    nextPage(id) {
      this.$router.replace({ name: 'CustomerList', params: { id } })
    },
    clickEnterpriseList() {
      this.showComponet = 'enterpriseList'
    },
    enterpriseList() {
      EnterpriseAPI.get(`enterprise/`)
        .then((res) => {
          this.count = res.result.count
          this.companys = res.result.list
          //console.log(res)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    signingList() {
      this.showComponet = 'signingList'
    },
    allow(company, str) {
      const confirmDialogString = str === 'allow' ? '開啟' : '關閉'
      let flag = company.isTeamAuthorized // 修改後
      company.isTeamAuthorized = !flag // 回復到修改前的值
      this.$confirm(`是否要${confirmDialogString}該企業權限？`, '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          company.isTeamAuthorized = flag
          this.changeAllowStatus(company.id, str)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '操作取消',
            showClose: true,
            duration: 1000,
          })
        })
    },
    changeAllowStatus(id, str) {
      EnterpriseAPI.put(`enterprise/auth?id=${id}&task=${str}`)
        .then(() => {
          this.enterpriseList()
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: '修改企業權限失敗',
            showClose: true,
          })
          console.error(err)
        })
    },
  },
}
</script>

<style scoped>
.tax-number {
  text-decoration: underline;
  color: blue;
}

.tax-number:hover {
  cursor: pointer;
}

/* .vue-Message { */
/*   display: none !important; */
/* } */
</style>



// WEBPACK FOOTER //
// src/pages/company/CompanyList.vue